export default __webpack_public_path__ + "static/media/htb-fernando.d843ec0a.jpg";